export const USERNAME_KEY = '@recipient'; // See BonusTemplate::PLACEHOLDER_RECIPIENT
